<template>
  <div class="c-siteMenuOverlay" :class="[{ 'is-open': isOpen }, menuClass]">
    <transition name="fade">
      <div
        class="c-siteMenuOverlay__background"
        @click="close"
        v-if="isOpen"
      ></div>
    </transition>
    <div class="c-siteMenuOverlay__inner" :class="placementClass">
      <div class="c-siteMenuOverlay__left">
        <div class="c-siteMenuOverlay__left__header">
          <div
            class="c-siteMenuOverlay__left__header__close o-btn o-btn--back"
            v-if="isOpen"
            @click="close"
          >
            <iBtnArrow />
            Tilbage
          </div>
        </div>
        <div class="c-siteMenuOverlay__left__body">
          <slot name="left"></slot>
        </div>
      </div>
      <div class="c-siteMenuOverlay__right">
        <div class="c-siteMenuOverlay__right__body">
          <!-- <transition name="fade"> -->
          <div class="c-siteMenuOverlay__right__body__menu" v-if="isMenu">
            <slot name="menu"></slot>
            <div class="c-siteMenuOverlay__right__body__menu__nav">
              <div class="c-siteMenuOverlay__right__body__menu__nav__icons">
                <div
                  class="c-siteMenuOverlay__right__body__menu__nav__icons-icon"
                  @click="openContact"
                >
                  <iPhone />
                  <p>Kontakt</p>
                </div>
                <div
                  class="c-siteMenuOverlay__right__body__menu__nav__icons-icon"
                  @click="openApps"
                >
                  <iApps />
                  <p>Apps</p>
                </div>
                <!-- <div class="c-siteMenuOverlay__right__body__menu__nav__icons-icon" @click="openLogin"><iUser /><p>Log ind</p></div> -->
                <!-- <div class="c-siteMenuOverlay__right__body__menu__nav__icons-icon" @click="openBasket"><iBasket /><p>Kurv</p></div> -->
              </div>
            </div>
          </div>
          <!-- </transition> -->
          <!-- <transition name="fade"> -->
          <div class="c-siteMenuOverlay__right__body__apps" v-if="isApps">
            <div class="c-siteMenuOverlay__right__header">
              <div
                class="c-siteMenuOverlay__right__header__back backbutton"
                @click="openMenu"
              >
                <iBtnArrow />
                Tilbage
              </div>
              <div
                class="c-siteMenuOverlay__right__header__close"
                @click="openMenu"
              >
                <iPlus />
              </div>
            </div>
            <slot name="apps"></slot>
          </div>
          <!-- </transition> -->
          <!-- <transition name="fade"> -->
          <div class="c-siteMenuOverlay__right__body__contact" v-if="isContact">
            <div class="c-siteMenuOverlay__right__header">
              <div
                class="c-siteMenuOverlay__right__header__back backbutton"
                @click="openMenu"
              >
                <iBtnArrow />
                Tilbage
              </div>
              <div
                class="c-siteMenuOverlay__right__header__close"
                @click="openMenu"
              >
                <iPlus />
              </div>
            </div>
            <slot name="contact"></slot>
          </div>
          <!-- </transition> -->
          <!-- <transition name="fade"> -->
          <div class="c-siteMenuOverlay__right__body__contact" v-if="isLogin">
            <div class="c-siteMenuOverlay__right__header">
              <div
                class="c-siteMenuOverlay__right__header__close"
                @click="openMenu"
              >
                <iPlus />
              </div>
            </div>
            <slot name="login"></slot>
          </div>
          <!-- </transition> -->
          <!-- <transition name="fade"> -->
          <div class="c-siteMenuOverlay__right__body__contact" v-if="isBasket">
            <div class="c-siteMenuOverlay__right__header">
              <div
                class="c-siteMenuOverlay__right__header__close"
                @click="openMenu"
              >
                <iPlus />
              </div>
            </div>
            <slot name="basket"></slot>
          </div>
          <!-- </transition> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import iBtnArrow from '@web/assets/icon/btnArrow.svg';

import iPhone from '@web/assets/icon/phone.svg';
import iApps from '@web/assets/icon/apps.svg';
import iUser from '@web/assets/icon/user.svg';
import iBasket from '@web/assets/icon/basket.svg';
import iPlus from '@web/assets/icon/plus.svg';

export default {
  name: 'SiteMenuOverlay',
  components: {
    iBtnArrow,
    iPhone,
    iApps,
    iUser,
    iBasket,
    iPlus,
  },

  data: () => ({
    isMenu: true,
    isApps: false,
    isContact: false,
    isLogin: false,
    isBasket: false,
    menuClass: '',
  }),

  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
    placement: {
      type: String,
      default: 'right',
    },
    showLoader: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    placementClass() {
      return 'c-siteMenuOverlay__inner' + '--' + this.placement;
    },
  },
  methods: {
    close() {
      this.isMenu = true;
      this.isApps = false;
      this.isContact = false;
      this.$emit('close');
    },
    toggle() {},
    openMenu() {
      this.isMenu = true;
      this.isApps = false;
      this.isContact = false;
      this.isLogin = false;
      this.isBasket = false;
      this.menuClass = '';
    },
    openContact() {
      this.isMenu = false;
      this.isApps = false;
      this.isContact = true;
      this.isLogin = false;
      this.isBasket = false;
      this.menuClass = 'c-siteMenuOverlay--menu';
    },
    openApps() {
      this.isMenu = false;
      this.isApps = true;
      this.isContact = false;
      this.isLogin = false;
      this.isBasket = false;
      this.menuClass = 'c-siteMenuOverlay--menu';
    },
    openLogin() {
      this.isMenu = false;
      this.isApps = false;
      this.isContact = false;
      this.isLogin = true;
      this.isBasket = false;
    },
    openBasket() {
      this.isMenu = false;
      this.isApps = false;
      this.isContact = false;
      this.isLogin = false;
      this.isBasket = true;
    },
  },
};
</script>

<style lang="scss">
@import '@backend/scss/abstracts/variables.scss';

.c-siteMenuOverlay {
  position: relative;

  .backbutton {
    svg {
      transition: all 0.4s cubic-bezier(0.46, 0.04, 0.13, 0.59);
      .hover {
        transition: all 0.4s cubic-bezier(0.46, 0.04, 0.13, 0.59);
      }
    }
    &:hover {
      svg {
        margin-right: 5px;
        transition: all 0.4s cubic-bezier(0.46, 0.04, 0.13, 0.59);
        .hover {
          transition: all 0.4s cubic-bezier(0.46, 0.04, 0.13, 0.59);
          fill: transparent;
        }
      }
    }
  }

  &__background {
    background-color: $c-overlay;
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 20;
  }

  &__inner {
    transition: $t-nice;
    display: flex;
    max-height: 100%;
    position: fixed;
    z-index: 20;
    top: 0;
    bottom: 0;
    opacity: 0;
    // width: calc(100% - 20px);
    width: 100%;
    max-width: 750px;
    background-color: $c-white;
    bottom: 0;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    transition: transform 500ms $t-nice, opacity 300ms $t-nice;

    &--left {
      left: 0;
      transform: translate(-100%, 0);
    }

    &--right {
      right: 0;
      transform: translate(100%, 0);
    }

    .is-open & {
      opacity: 1;
      transform: translate(0, 0);
    }
  }

  &__left {
    width: 440px;
    min-width: 440px;
    padding-top: 75px;
    padding-left: 100px;

    &__header {
      height: 35px;
      margin-bottom: 90px;

      &__close {
        cursor: pointer;
        display: flex;
        font-size: 13px;
        font-weight: $f-bold;
        line-height: 16px;
        text-transform: uppercase;
        margin-left: -26px;

        svg {
          transform: rotate(180deg);
          margin-right: 10px;
          width: 16px;
          .fill {
            fill: $c-red;
          }
        }
      }
    }

    &__body {
      height: calc(100% - 200px);
      overflow-y: scroll;
      overflow-x: hidden;

      &::-webkit-scrollbar {
        width: 5px;
      }
      -ms-overflow-style: none;
      scrollbar-width: none;

      &::-webkit-scrollbar-thumb {
        background-color: $c-darkblue;

        &:hover {
          background-color: darken($color: $c-darkblue, $amount: 10);
        }
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
    }
  }
  &__right {
    &::-webkit-scrollbar {
      width: 5px;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar-thumb {
      background-color: $c-darkblue;

      &:hover {
        background-color: darken($color: $c-darkblue, $amount: 10);
      }
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }

    padding-top: 75px;
    width: 100%;
    // max-width: 310px;
    background: #f8f8f8;
    border-left: 1px solid #e6e6e6;
    // padding-left: 45px;
    position: relative;
    overflow-y: scroll;

    &__header {
      height: 35px;
      display: flex;
      justify-content: flex-end;
      // align-items: center;
      padding-right: 45px;
      padding-left: 45px;
      margin-bottom: 90px;
      cursor: pointer;

      &__back {
        display: none;
        cursor: pointer;
        font-size: 13px;
        font-weight: $f-bold;
        line-height: 16px;
        text-transform: uppercase;
        // margin-left: -26px;
        align-items: flex-start;

        svg {
          transform: rotate(180deg);
          margin-right: 10px;
          width: 16px;
          .fill {
            fill: $c-red;
          }
        }
      }

      &__close {
        height: 100%;
        width: 45px;
        display: flex;
        justify-content: flex-end;
        svg {
          height: 16px;
          transform: rotate(45deg);
          path {
            fill: $c-darkblue;
            transition: $t-hover;
          }
        }

        &:hover {
          svg {
            path {
              fill: $c-red;
              transition: $t-hover;
            }
          }
        }
      }
    }

    &__body {
      position: relative;
      width: 100%;
      &__menu {
        padding-left: 45px;
        padding-top: 125px;
        &__nav {
          border-top: 1px solid #e6e6e6;
          margin-left: -45px;
          margin-top: 50px;
          padding-top: 35px;
          &__icons {
            display: flex;
            // justify-content: space-between;
            align-items: center;
            padding-left: 45px;
            padding-right: 45px;

            &-icon {
              margin-right: 30px;
              cursor: pointer;
              width: fit-content;
              display: flex;
              flex-direction: column;
              align-items: center;
              svg {
                height: 27px;

                path {
                  transition: $t-hover;
                  fill: $c-darkblue;
                }
              }
              p {
                transition: $t-hover;
                font-size: 11px;
                font-weight: $f-medium;
                text-align: center;
                line-height: 11px;
                margin-top: 5px;
                color: $c-darkblue;
              }

              &:hover {
                svg {
                  path {
                    transition: $t-hover;
                    fill: $c-red;
                  }
                }
                p {
                  transition: $t-hover;
                  color: $c-red !important;
                }
              }
            }
          }
        }
      }
      &__apps,
      &__contact {
        width: 100%;
        top: 0;
        position: absolute;
        background: #f8f8f8;
      }
    }
  }

  &--menu {
    .c-siteMenuOverlay {
      &__inner {
        transition: $t-nice;
        max-width: 805px;
      }
    }
  }

  &.is-open {
    .c-siteMenuOverlay__inner {
      opacity: 1;
      transform: translate(0, 0);
    }
  }
}

@media all and (max-width: 805px) {
  .c-siteMenuOverlay {
    &__left {
      width: 400px;
      min-width: 400px;
      padding-left: 70px;
    }
  }
}

@media all and (max-width: 767px) {
  .c-siteMenuOverlay {
    &__inner {
      flex-direction: column;
      max-width: 450px !important;
      overflow-y: scroll;
      overflow-x: hidden;

      &::-webkit-scrollbar {
        width: 5px;
      }
      -ms-overflow-style: none;
      scrollbar-width: none;

      &::-webkit-scrollbar-thumb {
        background-color: $c-darkblue;

        &:hover {
          background-color: darken($color: $c-darkblue, $amount: 10);
        }
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
    }
    &__left {
      width: 100%;
      padding-left: 45px;
      position: relative;

      &__header {
        margin-bottom: 30px;
      }

      &__body {
        height: fit-content;
        padding-bottom: 30px;
      }
    }
    &__right {
      width: 100%;
      padding-top: 0;
      flex-grow: 1;
      position: static;
      overflow-y: visible;
      padding-bottom: 60px;

      &__header {
        justify-content: flex-start;
        padding-left: 44px;
        margin-bottom: 30px;
        &__back {
          display: flex;
        }
        &__close {
          display: none;
        }
      }

      &__body {
        position: static;
        &__menu {
          padding-top: 45px;
        }

        &__apps,
        &__contact {
          padding-top: 75px;
          position: absolute;
          top: 0;
          background-color: #f8f8f8;
          width: 100%;
        }
      }
    }
  }
}
</style>
